/* eslint-disable no-console */

import { FC, useState, useEffect } from 'react'
import { useParams } from 'react-router'
import { Link } from 'react-router-dom'

import BlogBreadCrumbs from '../../components/breadcrumbs/blogBreadCrumbs'
// import PdpBreadCrumbs, { PdpBreadCrumbsProp } from '../../components/breadcrumbs/pdpBreadCrumbs/pdpBreadCrumbs'
import Page from '../../components/page'
import { BLOG_NOT_FOUND } from '../../constants'
import { fetchBlogs } from '../../features/blogs/blogSlice'
import { useI18n } from '../../hooks'
import { useAppDispatch, useAppSelector } from '../../store'
import { getDateString, getDefaultBlogBannerImage } from '../../utils'
import { Blog } from '../blogList'

import './blogContent.css'

const BlogContent: FC = () => {
  const dispatch = useAppDispatch()

  const { blogs, isLoading } = useAppSelector((state) => state.blogReducer)
  const { id }: { id: string } = useParams()
  const [blog, setBlog] = useState<Blog>()

  const { t } = useI18n()

  useEffect(() => {
    if (isLoading) return
    if (!blogs.length) Promise.all([dispatch(fetchBlogs())])
    else {
      const targetBlog = blogs.find((item): boolean => item.id === Number(id) || item.slug.toLowerCase() === id.toLowerCase())
      if (targetBlog) {
        setBlog(targetBlog)
      } else {
        window.location.pathname = BLOG_NOT_FOUND
      }
    }
  }, [blogs, dispatch, id, isLoading])

  const htmlContent = blog?.content || ''
  const authorUrl = `/blogs/author-${blog?.author.display_name.toLocaleLowerCase().replace(' ', '-')}`

  const bannerImageUrl = () => {
    if (blog) {
      return getDefaultBlogBannerImage(blog)
    }
  }
  const dateString = getDateString(blog?.modified_gmt)

  return (
    <Page
      metaData={{ title: t('BlogContent_meta_title'), description: t('BlogContent_meta_description'), charset: 'utf-8' }}
      className="blog-content-page"
    >
      <div className="blog-content-page-ctn">
        <BlogBreadCrumbs
          path={window.location.pathname}
          title={blog?.title || ''}
          // search={search}
          // locationPath={locationPath}
        />
        <h1 className="blog-content-title heavy">{blog?.title}</h1>
        <div className="blog-content-info">
          <img className="blog-content-avatar" src={blog?.author.avatar_links} alt={blog?.author.display_name} />
          <Link to={authorUrl} className="blog-content-author-name">
            {blog?.author.display_name}
          </Link>
          <span> | </span>
          <span className="blog-content-author-time">{dateString}</span>
        </div>
        <img src={bannerImageUrl()} className="blog-content-banner" alt={blog?.title} />

        <div className="blog-content-text-content" dangerouslySetInnerHTML={{ __html: htmlContent }}></div>
      </div>
    </Page>
  )
}

export default BlogContent
